/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_3_DInputs */

const en_cp_jr_3_d = /** @type {(inputs: Cp_Jr_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pitch on campus, then enter the national Build Challenge: judged on process, product and impact.`)
};

const id_cp_jr_3_d = /** @type {(inputs: Cp_Jr_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pitch di kampus, lalu entri ke Build Challenge nasional: dinilai dari proses, produk, dan dampak.`)
};

/**
* | output |
* | --- |
* | "Pitch on campus, then enter the national Build Challenge: judged on process, product and impact." |
*
* @param {Cp_Jr_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_3_d = /** @type {((inputs?: Cp_Jr_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_3_d(inputs)
	return en_cp_jr_3_d(inputs)
});